"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styles_1 = require("./styles");
exports.MenuItem = ({ iconPosition = 'right', route, onClick }) => {
    var _a;
    const handleOnClick = react_1.useCallback(() => {
        if (onClick)
            onClick(route);
    }, []);
    return (react_1.default.createElement(styles_1.Container, { to: (_a = route.linkPath) !== null && _a !== void 0 ? _a : route.path, onClick: handleOnClick },
        iconPosition === 'left' &&
            react_1.default.createElement(styles_1.Icon, { position: iconPosition }, route.icon),
        react_1.default.createElement(styles_1.Title, null, route.title),
        iconPosition === 'right' &&
            react_1.default.createElement(styles_1.Icon, { position: iconPosition }, route.icon)));
};
